import { useThemePerformanceReturn } from '@terminal/views/theme-overview/theme-overview-drawer/components/theme-performance-section/hooks/useThemePerformanceReturn';

import { ReactionMetric } from './ReactionMetric';

export interface ThemeOneDayReactionProps {
  themeId: string;
}

export const ThemeOneDayReaction = ({ themeId }: ThemeOneDayReactionProps) => {
  const { getReturnForHorizon } = useThemePerformanceReturn({ themeId });
  const value = getReturnForHorizon('1D');

  if (value === undefined) {
    return null;
  }

  return (
    <ReactionMetric
      i18nKey="widget:themeOverview.pulse.drawer.oneDayReaction"
      value={value}
    />
  );
};
